import {
  AccountableUsers,
  Header,
  AddUser,
  AddUserTitle,
  ActualUser,
  Avatar,
  CloseDiv,
} from "./styles";
import Close from "../../../assets/icons/Close";
import ProfileCircle from "../../../assets/icons/profileCircle";
import { useRef } from "react";
import { SearchInput } from "./SearchInput";
import { useOutsideDrop } from "../../../hooks/useOutsideDrop";

const AccountableWithConfirm = ({
  subtitle = "Responsável",
  placeholder = "+ Adicionar Responsável",
  list,
  id,
  open,
  user,
  style,
  disabled,
}) => {
  const [openSearch, setOpenSearch] = open;
  const [userACC, setUserACC] = user;
  const wrapperRef = useRef(null);
  const clearInput = () => setOpenSearch(false);
  useOutsideDrop(wrapperRef, clearInput);
  function updateAccountable(user) {
    setUserACC(user);
  }
  function removeAccountable() {
    setUserACC(null);
  }

  return (
    <AccountableUsers ref={wrapperRef} id={"accountable-" + id} style={style}>
      {subtitle ? (
        <Header>
          <span>{subtitle}</span>
        </Header>
      ) : null}

      <AddUser
        onClick={(e) => {
          e.stopPropagation();
          setOpenSearch(true);
        }}
      >
        {!openSearch && !userACC ? (
          <>
            <ProfileCircle height="1.7592rem" />
            <AddUserTitle>{placeholder}</AddUserTitle>
          </>
        ) : openSearch && !userACC ? (
          <SearchInput
            innerRef={wrapperRef}
            open={openSearch && !userACC}
            list={list}
            update={updateAccountable}
            onClose={() => setOpenSearch(false)}
          />
        ) : (
          <ActualUser>
            <Avatar src={userACC?.avatarURL} />
            <span>{userACC?.username}</span>
            {!disabled && (
              <CloseDiv>
                <Close
                  onClick={(e) => {
                    e.stopPropagation();
                    removeAccountable();
                  }}
                />
              </CloseDiv>
            )}
          </ActualUser>
        )}
      </AddUser>
    </AccountableUsers>
  );
};

export default AccountableWithConfirm;
